// @ts-nocheck
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import * as d3 from "d3";
window.d3 = d3;
import * as mapboxgl from "mapbox-gl";
window.mapboxgl = mapboxgl;
import { touchPunch } from "./js/helper/TouchHelper";
touchPunch();
import MapHandler from "./js/map/MapHandler";
import DataHandler from "./js/data/DataHandler";
import TangibleListener from "./js/tangible/TangibleListener";
import "./css/indicators.css";
import "./css/visdialogs.css";
import "./css/legends.css";
import "./css/style.css";
import "./css/isochrone.css";

const datahandler = new DataHandler();
const maphandler = new MapHandler("map", datahandler);
new TangibleListener(maphandler);

// Needed for Hot Module Replacement
if (typeof module.hot !== "undefined") {
  module.hot.accept(); // eslint-disable-line no-undef
}

